"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequest = void 0;
const ResponseError_1 = require("./ResponseError");
class BadRequest extends ResponseError_1.ResponseError {
    constructor(message = "Invalid input error.", errorDescriptions = []) {
        super("Bad request.", message, 400, errorDescriptions);
    }
}
exports.BadRequest = BadRequest;
//# sourceMappingURL=BadRequest.js.map